import { useCallback, useState } from 'react';

import { Button, Form, Input, message } from 'antd';

import { useChangePasswordValidation, passwordPolicyRules } from 'api';
import { UserPayload, userchangepassword } from 'api/profile';

type Props = {
  onSubmit: (values: UserPayload) => Promise<void>;
};
const inituser: UserPayload = {};

const ChangePassword = ({ onSubmit }: Props) => {
  //const { t } = useTranslation();

  const [form] = Form.useForm<UserPayload>();
  const [_user, setUser] = useState(inituser);
  const [ispLoading, setIspLoading] = useState(false);
  //const [ispasswordMatched, setpasswordMatched] = useState(false);

  function handleLoading(_e: any) {
    if (ispLoading === false) {
      setIspLoading(true);
    } else {
      setIspLoading(false);
    }
  }

  const validation = useChangePasswordValidation();
  const handleSubmit = useCallback(
    async (values: UserPayload) => {
      values.isActive = 1;
      values.userName = sessionStorage.getItem('user')?.toString();
      //if (sessionStorage.getItem('currentPassword')?.toString())
      userchangepassword(values).then((_res) => {
        setUser(_res.data);
        if (_res.data != null) {
          message.success('Password Changed!');
        }
        form.resetFields();
        setIspLoading(false);
      });
    },
    [onSubmit, form]
  );

  return (
    <>
      <div className="container" style={{ width: '60%' }}>
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-12">
            <div className="mid-container">
              <div className="submission-box">
                <h2>Change Password</h2>
                {/* <Title level={4}>{t('changePassword.title')}</Title> */}
                <Form<UserPayload>
                  form={form}
                  onFinish={handleSubmit}
                  layout="vertical"
                  scrollToFirstError
                >
                  <Form.Item
                    label="Current Password"
                    name="currentPassword"
                    rules={validation.currentPassword}
                    validateFirst
                  >
                    <Input.Password placeholder={'Current Password'} />
                  </Form.Item>
                  {/* {ispasswordMatched ? ( */}
                  <>
                    <Form.Item
                      label="New Password"
                      name="password"
                      rules={passwordPolicyRules}
                      validateFirst
                    >
                      <Input.Password placeholder={'New Password'} />
                    </Form.Item>

                    <Form.Item
                      required
                      label="Confirm Password"
                      name="confirmPassword"
                      className="Confirm Password"
                      //rules={validation.password}
                      rules={validation.confirmPassword}
                      validateFirst
                    >
                      <Input.Password placeholder="Confirm Password" />
                    </Form.Item>
                  </>
                  {/* ) : null} */}
                  <Button
                    type="primary"
                    htmlType="submit"
                    style={{ float: 'right', marginBottom: '10px' }}
                    onClick={handleLoading}
                  >
                    Submit
                  </Button>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ChangePassword;
